import classNames from 'classnames';
import FJDragBox from '../../../../common/components/FJDragBox/FJDragBox';
import styles from './FJPhotoRemoveBgRight.module.less';
import FJDisplayHeaderContainer from '../../../FJMainPreview/FJDisplayHeader/FJDisplayHeaderContainer';
import FJCreationEditPanelContainer from '../../../FJMainPreview/FJCreationEditPanel/container/FJCreationEditPanelContainer';
import FJHistoryPanelContainer from '../../../FJMainPreview/FJHistoryPanel/FJHistoryPanelContainer';
import PropTypes from 'prop-types';
import FJPhotoRemoveBgThumbnailContainer from '../container/FJPhotoRemoveBgThumbnailContainer';
import FJPhotoRemoveBgDownloadContainer from '../container/FJPhotoRemoveBgDownloadContainer';
import { useCallback } from 'react';
import FJEvent from '../../../../store/FJEvent';
import { FJ_EVENT_TYPE } from '../../../../constants/FJEvenTypeConstant';

const FJPhotoRemoveBgRight = props => {
    const {
        uploadFile,
        setIsDraggingFile,
        multipleUpload,
        initImagePadding,
        offsetTop,
        hasEditImage,
        disableDragUpload,
    } = props;

    const mouseDownPanel = useCallback(() => {
        FJEvent.dispatch(FJ_EVENT_TYPE.HIDE_QUICK_SELECTION_BOX);
        FJEvent.dispatch(FJ_EVENT_TYPE.HIDE_SIDE_MODAL);
    }, []);

    return (
        <FJDragBox
            disable={disableDragUpload}
            setIsDragging={setIsDraggingFile}
            multipleUpload={multipleUpload}
            uploadFile={uploadFile}
            onPanelMouseDown={mouseDownPanel}
            className={classNames(styles.app_right)}
        >
            <FJDisplayHeaderContainer
                isShowProgress={false}
                rightChildren={<FJPhotoRemoveBgDownloadContainer />}
                hasEditImage={hasEditImage}
            />

            <FJCreationEditPanelContainer
                activeHeaderTabIndex={0}
                initImagePadding={initImagePadding}
                offsetTop={offsetTop}
            />

            <FJPhotoRemoveBgThumbnailContainer />

            <FJHistoryPanelContainer activeHeaderTabIndex={1} />
        </FJDragBox>
    );
};

FJPhotoRemoveBgRight.propTypes = {
    uploadFile: PropTypes.func.isRequired,
    setIsDraggingFile: PropTypes.func.isRequired,
    multipleUpload: PropTypes.bool,
    initImagePadding: PropTypes.object,
    offsetTop: PropTypes.number,
    hasEditImage: PropTypes.bool,
    disableDragUpload: PropTypes.bool,
};

export default FJPhotoRemoveBgRight;
